export default [
  {
    path: "/login",
    name: "login",
    component: _ => import("@/pages/login/login.vue"),
    meta: {
      // 页面标题title
      title: '登录中心'
    }
  },
  {
    path: "/login/token",
    name: "loginToken",
    component: _ => import("@/pages/login/token.vue"),
    meta: {
      // 页面标题title
      title: '开发版登录'
    }
  },

]
